import { render, staticRenderFns } from "./VersionUpdateNotifier.vue?vue&type=template&id=2f7835f2&"
import script from "./VersionUpdateNotifier.vue?vue&type=script&lang=js&"
export * from "./VersionUpdateNotifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VProgressCircular,VSnackbar})
